import React from 'react'
import { FaPencil } from "react-icons/fa6";

export default function Attributes() {
  return (
    <div>
    <button style={{
        marginTop: "20px",
        backgroundColor: "#004aad",
        color: "white",
        padding: "10px 15px",
        borderRadius: "5px",
        border: "none",
        cursor: "pointer",
    
       }}>
        <FaPencil /> Save
    </button>
    </div>
  )
}
